import { useaxios } from "../../../../utils/useaxios";
export default (employ_id, employ_state) => setloading => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    setloading(true);
    useaxios('employ/chanestate.php', { employ_id, employ_state }).then((res) => {
        console.log(res);
        if (res.status == "ok") {
        } else {
            // clear();
        }
        setloading(false);
    });
}